import React, { Component } from 'react';
import toastr from 'toastr';
import axios from 'axios';

export default class EditPhoto extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: '',
            image: '',
            caption: new String
        };
    }

    onChange(e) {
        this.setState({ [e.target.name]:e.target.value});
    }

    async componentDidMount() {
        const id = this.props.match.params.id;
        this.setState({ id });

        await axios.get(`/photo/${id}/edit`)
            .then(res => this.setState({ image: res.data, caption: res.data.caption }))
            .catch(e => console.log(e));
    }

    update(e) {
        e.preventDefault();
        let caption = this.state.caption;

        let formData = new FormData();
        formData.append("caption", caption);

        axios.post(`/photos/${this.state.id}/trying`, formData)
            .then(res => {
                this.setState({ caption });
                toastr.success('Successfully updated photo caption!', 'Woot Woot');
            })
            .catch(e => {
                console.log(e);
                // toastr.error('Something went wrong', 'Mouahahahahah!');
            });
    }

    render() {
        return (
            <div className="container text-center">
                <div className="alert alert-info mb-3">
                    <h1 className="text-primary"><strong>Edit Photo</strong></h1>
                </div>
                <img
                    src={"/"+this.state.image.uri}
                    alt={this.state.image.caption || "Image to update"}
                    className="img-fluid mb-3"
                />

                <div className="form-group">
                    <textarea
                        name="caption"
                        className="form-control"
                        onChange={this.onChange.bind(this)}
                        value={this.state.caption || ""}
                        placeholder="Enter Image Caption"
                        ></textarea>
                </div>
                <div className="form-group">
                    <input className="form-control btn btn-info" onClick={this.update.bind(this)} type="submit" value="Update"/>
                </div>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/EditPhoto.js